import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueMarkdownEditor from '@kangc/v-md-editor';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress';
import deDE from '@kangc/v-md-editor/lib/lang/de-DE';
import Prism from 'prismjs';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';

// Prism
// highlight code
import 'prismjs/components/prism-json';

VueMarkdownEditor.use(vuepressTheme, {
  Prism,
});
VueMarkdownEditor.lang.use('de-DE', deDE);

Vue.use(VueMarkdownEditor);

Vue.use(VueAxios, axios);
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : 'https://helpcom_backend.cluster.hfg.gd/';
axios.defaults.withCredentials = true;

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    /*
    toast(title, text, variant = null) {
    this.$bvToast.toast(text, {
      title,
      variant,
        solid: true,
        autoHideDelay: 2000,
        toaster: 'b-toaster-top-right',
        appendToast: false,
      });
    },
    */
    logout() {
      store.state.loggedIn = false;
      store.state.authInfo = {
        id: null,
        email: null,
        preName: null,
        lastName: null,
        permissions: null,
      };
      axios.post('auth/logout');
      router.push('/login');
    },
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.state.authInfo.id === null) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
      // this.toast('Es ist ein Fehler aufgetreten', 'Du musst dich zuerst anmelden!', 'danger');
      store.state.loggedIn = false;
    } else {
      next();
      store.state.loggedIn = true;
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
